module.exports = __webpack_public_path__ + "img/room_run2.186581ea.png";